import { Grid, Typography } from "@mui/material";
import Image from "next/image";
import Flag from "../../../public/assets/images/home/Flag.webp";
import StatsBorderTop from "../../../public/assets/images/home/StatsBorderTop.webp";
import StatsOrangeBand from "../../../public/assets/images/home/StatsOrangeBand.webp";
import StatsGreenBand from "../../../public/assets/images/home/StatsGreenBand.webp";
import StatsBgImg from "../../../public/assets/images/home/image-135.webp";
import { NUMBER_OF_DOWNLOADS } from "../../../utils/Constants";

const Stats: React.FC = () => {
  return (
    <Grid
      container
      sx={{
        width: "100vw",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        position: "relative",
        padding: { xs: "50px 0 0 0", md: "60px 0 0 0" },
        minHeight: { xs: "50vh", md: "50vh" },
        mb: 8,
        display: "flex",
      }}
    >
      <Grid
        sx={{
          height: { xs: "32px", md: "48px" },
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
        }}
      >
        <Image
          src={StatsBorderTop}
          alt=""
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
          loading="lazy"
        />
      </Grid>
      <Grid
        sx={{
          width: "100%",
          maxWidth: "1200px",
          margin: "auto",
          display: "block",
          padding: { xs: "12px 24px 16px", md: "24px 24px 16px" },
        }}
      >
        <Grid
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            paddingBottom: { xs: "16px", md: "24px" },
          }}
        >
          <Typography
            variant="body1"
            fontWeight="bold"
            textAlign="center"
            color="#6C717F"
            textTransform="capitalize"
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontSize: { xs: "16px", md: "20px" },
              paddingLeft: { xs: "0", md: "0" },
            }}
          >
            <span>Made for India, Made in India</span>
            <Image
              src={Flag}
              alt="Indian flag icon"
              style={{
                height: "42px",
                width: "42px",
                marginLeft: "4px",
                verticalAlign: "middle",
              }}
              loading="lazy"
            />
          </Typography>
        </Grid>

        <Grid
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Grid
            sx={{
              width: { xs: "20%", md: "360px" },
              height: { xs: "16px", md: "fit-content" },
            }}
          >
            <Image
              src={StatsOrangeBand}
              alt=""
              // width={720}
              // height={52}
              // style={{ width: "720px", height: "52px" }}
              loading="lazy"
            />
          </Grid>
          <Typography
            textAlign="center"
            fontWeight="bold"
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              paddingBottom: { xs: "10px", md: "0" },
              fontSize: { xs: "40px", md: "64px" },
              zIndex: 2,
              whiteSpace: "nowrap",
            }}
          >
            {NUMBER_OF_DOWNLOADS + " " + "Lakh+"}
          </Typography>
          <Grid
            sx={{
              width: { xs: "20%", md: "360px" },
              height: { xs: "16px", md: "fit-content" },
            }}
          >
            <Image
              src={StatsGreenBand}
              alt=""
              // width={720}
              // height={52}
              // style={{ width: "720px", height: "52px" }}
              loading="lazy"
            />
          </Grid>
        </Grid>
        <Typography
          textAlign="center"
          fontWeight="700"
          sx={{
            textShadow: "0px 0px 4px white",
            fontSize: { xs: "18px", md: "32px" },
            width: { xs: "70%", md: "fit-content" },
            margin: "auto",
            paddingBottom: { xs: "8px", md: "16px" },
          }}
        >
          Partners have earned ₹100 Crores till now!
        </Typography>
        <Typography
          textAlign="center"
          sx={{
            textShadow: "0px 0px 2px white",
            fontSize: { xs: "13px", sm: "14px", md: "18px" },
            lineHeight: { xs: "19px", sm: "20px", md: "26px" },
            width: { xs: "86%", md: "720px" },
            margin: "auto",
            fontWeight: 500,
            opacity: 0.95,
            paddingBottom: { xs: "12px", md: "40px" },
          }}
        >
          GroMo is a free app that turns you into a certified financial advisor.
          Share product links, help people get credit cards &amp; loans, earn
          commission on every sale. No investment needed.
        </Typography>
      </Grid>
      {/* <Image
        src={StatsBgImg}
        alt="Partners have earned ₹100 Crores till now!"
        style={{ width: "100%", objectFit: "contain" }}
        loading="eager"
        priority
      
      /> */}
    </Grid>
  );
};

export default Stats;
